const SELECTOR = ".js-header__account-menu";
const TOGGLE_SELECTOR = ".js-header__account-menu__toggle";
// const LIST_SELECTOR = ".js-header__account-menu__list";
const IS_OPEN_CLASSNAME = "is-open";

class EnterpriseAccountMenu {
    static attach() {
        const menuElement = document.querySelector(SELECTOR);

        if (menuElement) {
            /* eslint-disable-next-line no-unused-vars */
            const accountMenu = new EnterpriseAccountMenu(menuElement);
        }
    }

    constructor(menuElement) {
        this.isOpen = false;
        this.menuElement = menuElement;
        const toggleElement = document.querySelector(TOGGLE_SELECTOR);

        if (toggleElement) {
            toggleElement.addEventListener("click", () => {
                this.toggleIsOpen();
            });
        }

        this.updateView();
    }

    toggleIsOpen() {
        this.isOpen = !this.isOpen;
        this.updateView();
    }

    updateView() {
        if (this.isOpen) {
            this.menuElement.classList.add(IS_OPEN_CLASSNAME);
        } else {
            this.menuElement.classList.remove(IS_OPEN_CLASSNAME);
        }
    }
}

export { EnterpriseAccountMenu };
